import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getEmailTemplate, updateEmailTemplate} from 'src/openapi/admin/apis/MicroSitesEmailTemplateCustomizationApi';
import {useAppDispatch} from 'src/store/hooks';

import type {EmailCustomization} from 'src/openapi/admin/models/EmailCustomization';

type Props = {
    accountId: number,
};

export const useEmailSetup = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getEmailTemplate({accountId}, {signal}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((
        emailCustomization: EmailCustomization,
        signal: AbortSignal,
    ) => apiDispatch(
        updateEmailTemplate({accountId, emailCustomization}, {signal}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            subject: '',
            body: '',
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
